import { useForm } from "react-hook-form";
import { useUtilitiesContext } from "../context/UtitlitiesContext";
import { postFormDataHelper } from "../../../services/apiService/apiHelper";
import { endpoints } from "../../../services/apiService/endpoint";
import { toast } from "react-toastify";

const UseUtilityHook = () => {
  const {
    AddSliderImages,
    setAddSliderImages,
    AddSliderBinaryImages,
    setAddSliderBinaryImages,
    AddMobileSliderImages,
    setAddMobileSliderImages,
    AddMobileSliderBinaryImages,
    setAddMobileSliderBinaryImages,
  } = useUtilitiesContext();

  const {
    register,
    handleSubmit,
    formState: { errors: error },
    watch,
    reset,
  } = useForm({
    mode: "onBlur",
  });

  const handleSliderFileUpload = (event) => {
    const files = Array.from(event.target.files);
    setAddSliderBinaryImages(files);
    const fileURLs = files.map((file) => URL.createObjectURL(file));
    setAddSliderImages((prevImages) => [...prevImages, ...fileURLs]);
  };

  const handleMobileSliderFileUpload = (event) => {
    const files = Array.from(event.target.files);
    setAddMobileSliderBinaryImages(files);
    const fileURLs = files.map((file) => URL.createObjectURL(file));
    setAddMobileSliderImages((prevImages) => [...prevImages, ...fileURLs]);
  };

  const handleSliderSubmit = async (data) => {
    try {
      console.log("slider data", data);

      // form data instance
      const formData = new FormData();

      // set slider images
      if (AddSliderBinaryImages.length > 0) {
        AddSliderBinaryImages.forEach((image) => {
          formData.append("images_web", image);
        });
      }

      if (AddMobileSliderBinaryImages.length > 0) {
        AddMobileSliderBinaryImages.forEach((image) => {
          formData.append("images_mobile", image);
        });
      }

      // rest form data
      formData.append("title", data.slider_name || "");
      formData.append("link", data.slider_link || "");
      formData.append("order", data.slider_order || "");
      formData.append("status", data.slider_status || "");

      // post form data
      const response = await postFormDataHelper(endpoints.addSlider, formData);

      console.log("response", response);

      if (response.data.status) {
        toast.success(response.data.message, { autoClose: 800 });
        reset();
        setAddSliderImages([]);
        setAddMobileSliderImages([]);
      }
    } catch (err) {
      console.log("Error in handleSlider Submit", err);
      toast.error(err.response.data.message, { autoClose: 800 });
    }
  };

  return {
    register,
    handleSubmit,
    error,
    watch,
    AddSliderImages,
    setAddSliderImages,
    AddMobileSliderImages,
    setAddMobileSliderImages,
    handleSliderFileUpload,
    handleMobileSliderFileUpload,
    handleSliderSubmit,
  };
};

export default UseUtilityHook;
